<template>
    <b-overlay :show="isBusy" rounded="sm">
        <ver-apagar-arquivo v-if="arquivoPrincipal" :key="`ver-apagar-arquivo-principal-${item.Id}`"
            :arquivo="arquivoPrincipal" :canRemove="!item.actions.isSugerivel && canRemove" @verarquivo="viewFile"
            @removerarquivo="removeFile"></ver-apagar-arquivo>
        <b-card v-if="item.actions.isSugerivel" class="mt-1" :no-body="ratifica">
            <template #header>
                Ratifica o relatório carregado?
                <b-form-radio-group v-model="ratifica" :options="ratificaOptions" size="sm"
                    @change="trocarRespostaSugerivel()" :disabled="ro"></b-form-radio-group>
            </template>
            <b-card-body v-if="ratifica === false">
                <enviar-arquivo-cell v-if="!existeRetificado() && !ro"
                    :key="`enviar-arquivo-em-acoes-arquivo-cell-${item.Id}`" :itemID="item.Id"
                    :newIdPrestacaoConta="newIdPrestacaoConta"
                    @updateAll="(dados) => updateData(dados)"></enviar-arquivo-cell>
                <ver-apagar-arquivo v-if="existeRetificado()" :key="`ver-apagar-arquivo-retif-${item.Id}`"
                    :arquivo="getArquivoRetificado()" :canRemove="canRemove" @verarquivo="viewFile"
                    @removerarquivo="removeFile">
                </ver-apagar-arquivo>
            </b-card-body>
        </b-card>
    </b-overlay>
</template>

<script>
import pcaService from "@/services/entregas/pcaService";
import EnviarArquivoCell from '@/components/pca/EnviarArquivoCell.vue'
import VerApagarArquivo from '@/components/pca/VerApagarArquivo.vue'

export default {
    props: {
        item: {
            type: Object
        },
        canRemove: {
            type: Boolean,
            default: false
        },
        newIdPrestacaoConta: {
            type: Number
        },
        ro: { // read-only
            type: Boolean,
            default: false
        }
    },
    components: { EnviarArquivoCell, VerApagarArquivo },
    data() {
        return {
            isBusy: false,
            ratifica: true,
            ratificaOptions: [
                { text: 'Ratifico', value: true },
                { text: 'Retificação com justificativa', value: false },
            ],
            arquivoPrincipal: null,
        }
    },
    methods: {
        async viewFile(codArquivo) {
            try {
                this.isBusy = true
                const response = await pcaService.viewFile(
                    codArquivo,
                    this.newIdPrestacaoConta
                );
                if (response && response.status == 200) {
                    let hash = response.data;
                    window.open(
                        process.env.VUE_APP_ENTREGAS_API + "/PCA/obterArquivo/" + hash,
                        "_blank"
                    );
                } else {
                    if (response) this.$toast.error(response.data.msg);
                    else this.$toast.error("Erro ao abrir o arquivo");
                }
            } catch (e) {
                console.error('Erro em EntregaPCA.viewFile', e)
                this.$toast.error('Erro ao abrir arquivo');
            } finally {
                this.isBusy = false;
            }
        },
        async removeFile(cod) {
            try {
                this.isBusy = true;
                const response = await pcaService.removeFile(
                    cod,
                    this.newIdPrestacaoConta
                );
                if (response && response.status == 200) {
                    this.$emit("updateAll", response.data);
                    this.$toast.success('Arquivo removido!');
                } else {
                    if (response) this.$toast.error(response.data.msg);
                    else this.$toast.error("Erro ao remover o arquivo");
                }
            } catch (e) {
                console.error('Erro em EntregaPCA.AcoesArquivoCell.removeFile', e)
                this.$toast.error('Erro ao remover arquivo');
            } finally {
                this.isBusy = false;
            }
        },
        trocarRespostaSugerivel() {
            //console.log('trocou para ', this.ratifica)
            if (this.ratifica) {
                this.$bvModal.msgBoxConfirm('Tem certeza que deseja descartar esta retificação?', {
                    buttonSize: 'sm',
                    cancelTitle: 'Não',
                    cancelVariant: 'outline-secondary',
                    centered: true,
                    headerBgVariant: 'secondary',
                    headerTextVariant: 'light',
                    okTitle: 'Sim, apague o arquivo de retificação',
                    title: 'Confirmar exclusão de arquivo',
                }).then(value => {
                    //console.log('usuário respondeu', value)
                    if (value) {
                        const arqRetif = this.getArquivoRetificado()
                        this.removeFile(arqRetif.CodArquivo)
                    } else {
                        this.ratifica = false
                    }
                }).catch(err => {
                    console.error('Erro ao remover arquivo retificado', err)
                })
            }
        },
        /** criminosamente repasso o evento para o componente pai */
        updateData(dados) {
            this.$emit("updateAll", dados);
        },
        existeRetificado() {
            //console.log('existeRetificado para ', this.item.arquivos, this.item && this.item.actions.isSugerivel && this.item.arquivos && this.item.arquivos.some(file => !file.Sugerido))
            if (this.item && this.item.actions.isSugerivel && this.item.arquivos && this.item.arquivos.some(file => !file.Sugerido)) {
                return true
            } else {
                return false
            }
        },
        getArquivoRetificado() {
            if (this.existeRetificado()) {
                return this.item.arquivos.find(file => !file.Sugerido)
            } else {
                return null
            }
        }
    },
    mounted() {
        try {
            const arq = this.item.arquivos.find(arq => arq.Sugerido) ?? this.item.arquivos[0]
            //console.log('acoesArquivoCell recebeu', this.item.Ordem, arq.NomeOriginal, this.item)

            this.isBusy = true
            if (this.item.arquivos && this.item.arquivos.length > 0) {
                this.arquivoPrincipal = this.item.arquivos.find(arq => arq.Sugerido) ?? this.item.arquivos[0]
            }
            if (this.existeRetificado()) {
                this.ratifica = false
            }

        } finally {
            this.isBusy = false
        }
        //
        /* if (this.item.actions.isSugerivel) {
            console.log('olar', this.item)
        } */
    }
}
</script>

<style scoped>
h6.card-subtitle {
    font-size: 0.8rem;
}

div.card-body {
    padding: 0.5rem;
}
</style>